<script setup lang="ts">
import { useRemoveFromWaitlist } from "@/composables/waitlist";

defineProps<{ notificationId: number }>();
const { onRemoveFromWaitlist, isDisabled, icon } = useRemoveFromWaitlist();
</script>

<template>
  <button class="btn-outline-circle" :disabled="isDisabled" @click="onRemoveFromWaitlist({ notification_id: notificationId })">
    <span class="size-6" :class="icon" />
  </button>
</template>
